module.exports = __webpack_public_path__ + "static/media/1.95807eae.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/cei/1.mp3
// module id = 473
// module chunks = 0